import { ILoginInput, LoginStep } from '../types';
import { Updater } from 'use-immer';

export const goBackToLoginStep = ({
  setLoginStep,
  setLoginInput,
}: {
  setLoginStep: (step: LoginStep) => void;
  setLoginInput: Updater<ILoginInput>;
}) => {
  setLoginInput((draft) => {
    draft.password = '';
  });
  setLoginStep(LoginStep.NotLoggedIn);
};
